import { render, staticRenderFns } from "./StepTitle.vue?vue&type=template&id=37c76702&scoped=true"
import script from "./StepTitle.vue?vue&type=script&lang=js"
export * from "./StepTitle.vue?vue&type=script&lang=js"
import style0 from "./StepTitle.vue?vue&type=style&index=0&id=37c76702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c76702",
  null
  
)

export default component.exports